export default __webpack_public_path__ + "static/media/Alegreya-Regular.24bad425.ttf";